// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.studyViewer-navbar-brand span {
  font-size: 18px;
  font-weight: bold;
}

#complete-tab {
  display: flex;
  align-items: center;
}

.closeBtn {
  margin-left: 10px;
  padding: 2px 8px;
  background: #d9534f;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
}

.closeBtn:hover {
  background: #c9302c;
}

.study-viewer {
  height: 100vh;
  width: 80%;
  display: flex;
  flex-direction: row;
}

.study-viewer-container {
  height: 75vh;
  width: 100%;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/components/StudyViewer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".studyViewer-navbar-brand span {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n#complete-tab {\n  display: flex;\n  align-items: center;\n}\n\n.closeBtn {\n  margin-left: 10px;\n  padding: 2px 8px;\n  background: #d9534f;\n  color: white;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.closeBtn:hover {\n  background: #c9302c;\n}\n\n.study-viewer {\n  height: 100vh;\n  width: 80%;\n  display: flex;\n  flex-direction: row;\n}\n\n.study-viewer-container {\n  height: 75vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
